import { Badge } from "@chakra-ui/react";
import { Tooltip } from "../Tooltip";
import { useTranslation } from "react-i18next";
import { SeQuestionStatus } from "../../../autogen/bff-api";
import { QUESTION_STATUS_COLORS } from "./questionStatusColors";

export const UnansweredQuestionsBadge = ({ count }: { count: number }) => {
  const { t } = useTranslation();
  const colors = QUESTION_STATUS_COLORS[SeQuestionStatus.Unanswered];

  if (count < 1) return null;

  return (
    <Tooltip label={t("Questions awaiting an answer from you")}>
      <Badge bg={colors.bg} color={colors.fg} rounded="md" flexShrink={0} textTransform="none">
        {t("{{count}} unanswered", { count })}
      </Badge>
    </Tooltip>
  );
};
